import React from 'react';
import Modal from '@mui/material/Modal';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const FileViewerModal = ({ open, onClose, data }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box className="mx-auto my-10 w-[90%] md:w-[70%] h-[90%] bg-white p-4 rounded-lg shadow-xl flex flex-col space-y-4 overflow-auto">
        
        {/* Header with Title and Close Button */}
        <div className="flex justify-between items-center">
          <Typography variant="h6" className="font-semibold text-gray-700">
            {data?.label}
          </Typography>
          <IconButton onClick={onClose} className="text-gray-600 hover:text-gray-900">
            <CloseIcon />
          </IconButton>
        </div>

        {/* File Previews */}
        {data?.files?.length > 0 &&
          data.files.map((file, index) => {
           if (file.content_type.startsWith('image/')) {
  return (
    <img
      key={index}
      src={`data:${file.content_type};base64,${file.data}`}
      alt={`img-${index}`}
      className="w-full rounded shadow"
    />
  );
}
 else if (file.content_type === 'application/pdf') {
              return (
                <iframe
                  key={index}
                  title={`pdf-${index}`}
                  src={`data:application/pdf;base64,${file.data}`}
                  className="w-full h-[600px] rounded"
                ></iframe>
              );
            } else {
              return (
                <pre
                  key={index}
                  className="bg-gray-100 p-2 rounded overflow-x-auto text-sm"
                >
                  {file.data}
                </pre>
              );
            }
          })}
      </Box>
    </Modal>
  );
};

export default FileViewerModal;
